import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable, forkJoin, of } from 'rxjs';
import { LookupService } from 'src/app/core/services/lookup.service';
import { ExternalUserProfileApiService } from '../../../shared/services/external-user-profile-api.service';

@Injectable({
	providedIn: 'root',
})
export class ExternalUserProfileResolver {
	constructor(
		private externalUserProfileApiService: ExternalUserProfileApiService,
		private lookupService: LookupService
	) {}

	resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> {
		const userId = route.paramMap.get('id');

		return forkJoin({
			user: userId == null ? this.externalUserProfileApiService.getUserProfileForCurrentUser() : this.externalUserProfileApiService.getUserProfile(userId),
			statuses: this.lookupService.getUserProfileStatuses(),
			clientUserRoles: this.lookupService.getClientUserRoles(),
			contractorUserRoles: this.lookupService.getContractorUserRoles(),
			myProfile: of(route.data.myProfile),
		});
	}
}
